import axios from "axios";

export const baseUrl="/";
// export const baseUrl="https://web.promotreking.com/";

export const loginApi = async (username, password) => {
    const response = await axios.post(`${baseUrl}api/v1/login`, {
        user_name: username, password
    });
    return response;
}

export const getServicesApi = async (token) => {
    const response = await axios.post(`${baseUrl}api/v1/secure/getServices`, null, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const getPublisherApi = async (service_id, token) => {
    const response = await axios.post(`${baseUrl}api/v1/secure/getPublisher`, {
        service_id
    }, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const addPublisherApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/secure/addPublisher`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
    return response;
}

export const editPublisherApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/secure/editPublisher`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const deletePublisherApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/secure/deletePublisher`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const togglePublisherApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/secure/enableDisablePublisher`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const dummyHitApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/secure/dummyHit`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const allPublisherApi = async (token) => {
    const response = await axios.post(`${baseUrl}api/v1/secure/allPublisher`, null, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const getTrafficApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/secure/fetchTraffic`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return response;
}

export const getSubscriptionApi=async(data,token)=>{
     const response = await axios.post(`${baseUrl}api/v1/secure/fetchPubSubscription`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return response;
}